// Mock data for DC Early Learning Collaborative website

export const logoUrl = "https://customer-assets.emergentagent.com/job_early-learn-dc/artifacts/v3f5rd06_DCELC%20Logo.png";

export const heroData = {
  title: "DC Early Learning Collaborative",
  subtitle: "Building a Thriving Future for Every Child",
  description: "A city where every child from birth to age 5 has equitable access to high-quality early education and care.",
  ctaText: "Get Involved",
  secondaryCtaText: "Learn More",
  backgroundImage: "https://images.unsplash.com/photo-1666888736026-62d89f6cc7a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmZW1hbGUlMjBjYXJlZ2l2ZXIlMjB0b2RkbGVycyUyMGJvb2tzJTIwcmVhZGluZyUyMGZsb29yJTIwY2FycGV0JTIwY2hpbGRjYXJlJTIwY2VudGVyfGVufDB8fHx8MTc2ODYwNTY2M3ww&ixlib=rb-4.1.0&q=85"
};

export const missionData = {
  vision: {
    title: "Vision",
    description: "We envision a future where every child enters school with a strong foundation built on high-quality early childhood educational experiences. We strive for a future where early learning experiences close the opportunity and achievement gaps, educators are valued and supported, families are engaged, and communities unite to create equitable opportunities that last for generations."
  },
  mission: {
    title: "Mission",
    description: "The DC Early Learning Collaborative (DCELC) strives to ensure that all children receive high-quality Early Childhood Education (ECE) by advocating for equity, strengthening the workforce, shaping policy, and building a better system of early care and education. Through partnerships, education of the public, and policy advocacy, we elevate ECE professionals, empower families, and create a more inclusive, effective early learning system where every child thrives and reaches their full potential."
  },
  theoryOfChange: {
    title: "Theory of Change",
    description: "If DCELC strengthens awareness, action, and education among diverse stakeholders, then systemic inequities will be diminished, the educator workforce will be adequately supported, and high-quality ECE will be recognized and funded as a public good."
  },
  values: [
    {
      title: "Equity",
      description: "We are committed to dismantling systemic barriers and ensuring that children of color and all children receive high-quality, engaging educational experiences that nurture their full potential."
    },
    {
      title: "Advocacy",
      description: "We champion systemic change, amplifying the voices of ECE professionals, children, and families to influence policy and public perception."
    },
    {
      title: "Excellence",
      description: "We strive to build a highly skilled, well-compensated, and well-supported ECE workforce that delivers exceptional education and care."
    },
    {
      title: "Partnership",
      description: "We strengthen connections between families, educators, and local organizations, fostering community-driven solutions that enhance early learning opportunities."
    },
    {
      title: "Growth & Development",
      description: "We work to elevate the role, value, and competency of ECE professionals, ensuring they receive the respect, compensation, and acknowledgment they deserve."
    },
    {
      title: "Legacy",
      description: "We focus on long-term solutions to create a stable, thriving ECE system, benefitting children, families, and educators for generations to come."
    }
  ]
};

export const aboutData = {
  title: "Who We Are",
  subtitle: "Our Role in Advancing Early Childhood Education",
  description: "The DC Early Learning Collaborative (DCELC) stands at the forefront of advancing equitable access to high-quality early childhood education (ECE) across Washington, DC. As a trusted convener of educators, policymakers, and community leaders, DCELC brings together diverse voices to strengthen the city's early learning system and champion policies that uplift children, families, and the workforce that serves them.",
  leadershipTitle: "A Decade of Leadership and Advocacy",
  leadershipDescription: "Over the past decade, under the leadership of Carrie Thornhill, Sia Barbara Kamara, Dr. Beverly Jackson, and the late Maurice R. Sykes, DCELC has built powerful connections rooted in advocacy, collaboration, and community-driven leadership, continuing the legacy of the historic Pre-K for All DC movement that transformed early education in the District.",
  image: "https://customer-assets.emergentagent.com/job_early-learn-dc/artifacts/xstymvuf_Male%20Early%20Educator.jpg"
};

export const strategicVisionData = {
  title: "Strategic Vision for 2026–2029",
  description: "Our 2026–2029 strategic plan builds on this foundation by deepening DCELC's commitment to positioning early childhood education as a public good, an essential pillar of the District's educational progress, workforce stability, and long-term economic health.",
  goals: [
    {
      id: 1,
      title: "Strengthen Internal Capacity",
      description: "Build organizational strength to better serve our community and partners."
    },
    {
      id: 2,
      title: "Expand Professional Development",
      description: "Create pathways for Directors, programs, and educators to grow professionally."
    },
    {
      id: 3,
      title: "Lead Coordinated Advocacy",
      description: "Secure equitable funding and systemic reform through unified action."
    },
    {
      id: 4,
      title: "Community Mobilization",
      description: "Ensure every child, regardless of zip code, has the opportunity to thrive."
    }
  ],
  image: "https://images.pexels.com/photos/8422248/pexels-photo-8422248.jpeg"
};

export const organizationData = {
  title: "Organizational Overview",
  subtitle: "A Cross-Sector Coalition for Early Learning",
  description: "The DC Early Learning Collaborative (DCELC) is a powerful cross-sector coalition of educators, advocates, community-based organizations, and policymakers united by a shared commitment to strengthening the District's early learning system.",
  legacy: "As the successor to Pre-K for All DC, which led the passage of the landmark Pre-K Expansion and Enhancement Act of 2008, legislation that became a national model, DCELC continues to serve as a driving force for innovation, collaboration, and equity in early education.",
  governanceTitle: "Inclusive Governance and Representation",
  governanceDescription: "DCELC's governance structure reflects the strength of its coalition and the diversity of the field it represents. Its 15-member board includes leaders from key associations.",
  partners: [
    "DC Association for the Education of Young Children",
    "DC Family Child Care Association",
    "DC Head Start Association",
    "Washington Association of Child Care Centers",
    "Directors Exchange",
    "Multicultural Spanish Speaking Providers Association"
  ]
};

export const quoteData = {
  quote: "When you do the right thing for children, you believe in the inherent value of every child, regardless of background.",
  author: "Maurice R. Sykes",
  role: "DCELC Leader & Visionary"
};

export const contactData = {
  title: "Get in Touch",
  subtitle: "Have questions or need more information? We're here to help!",
  phone: "(202) 961-5502",
  email: "admin@dcelc.org",
  address: "700 Pennsylvania Ave. S.E 2nd Floor",
  city: "Washington, DC 20003",
  socialMedia: {
    facebook: "https://www.facebook.com/dcearlylearning/",
    instagram: "https://www.instagram.com/dcearlylearningcollaborative/",
    youtube: "https://www.youtube.com/@dcearlylearningcollaborati405",
    linkedin: "https://www.linkedin.com/posts/dc-early-learning-collaborative_dcearlylearning-earlychildhood-eceisapublicgood-activity-7439729920508841985-dv1i"
  },
  backgroundImage: "https://images.pexels.com/photos/129112/pexels-photo-129112.jpeg"
};

export const navLinks = [
  {
    name: "Home",
    href: "#home",
    dropdown: true,
    items: [
      { name: "Home", href: "#home" },
      { name: "About", href: "#about" },
      { name: "Vision", href: "#vision" },
      { name: "Organization", href: "#organization" }
    ]
  },
  { name: "Our Work Priorities", href: "/work-priorities" },
  { name: "In The Community", href: "/community" },
  { name: "ECE Professional Development", href: "/professional-development" },
  { name: "Contact", href: "#contact" }
];
